import FivePhdImage from "../../images/Five_PhD_Application_Tips.png";
import FiveMistakes from "../../images/Five_Common_Mistakes.png";
import HowToApply from "../../images/How_To_Apply.png";
import SixBooks from "../../images/Six_Books_For_PhD.png";
import StudentVisaPhD from "../../images/PhD_Visas.png";


export const articles = [
  {
    id: 1,
    title: "5 PhD Application Tips",
    description:
      "Researching supervisors, proposing your own project, and following key tips can help you secure PhD funding and succeed in your application.",
    author: "Landon Amaba",
    readTime: "3 min read",
    thumbnail: FivePhdImage,
  },
  {
    id: 2,
    title: "Graduate School: 5 Common Misakes",
    description: "Start your grad school journey strong by avoiding these common mistakes",
    author: "Landon Amaba",
    readTime: "4 min read",
    thumbnail: FiveMistakes,
  },
  {
    id: 3,
    title: "Graduate School: How to Apply",
    description: "Take the first steps in becoming a PhD student!",
    author: "Landon Amaba",
    readTime: "2 min read",
    thumbnail: HowToApply,
  },
  {
      id: 4,
      title: "6 Books every PhD student should read",
      slug: "6-books-every-phd-student-should-read",
      description: "Starting (and surviving) a PhD isn’t just about doing research—it’s about navigating an entirely new world.",
      author: "Landon Amaba",
      readTime: "4 min read",
      thumbnail: SixBooks,
    },
  {
      id: 5,
      title: "Student Visas for PhDs",
      slug: "student-visas-for-phds",
      description: "Navigating the U.S. student visa process can feel overwhelming, but understanding each step is key to securing your PhD journey and planning for life after graduation",
      author: "Landon Amaba",
      readTime: "6 min read",
      thumbnail: StudentVisaPhD ,
    },
];
